var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.943 14.27-.338-2.133a4.535 4.535 0 0 1-.677-.322 4.651 4.651 0 0 1-.626-.423l-1.997.914L.73 9.531l1.827-1.337a2.012 2.012 0 0 1-.042-.347 8.077 8.077 0 0 1 0-.694c.006-.13.02-.245.042-.347L.731 5.47l1.574-2.775 1.997.914c.18-.147.389-.288.626-.423.237-.136.462-.237.677-.305L5.943.73h3.114l.338 2.133c.215.079.443.183.686.313.242.13.448.274.617.432l1.997-.914 1.574 2.775-1.827 1.303c.022.113.036.234.042.364a8.407 8.407 0 0 1 0 .72c-.006.123-.02.242-.042.355l1.827 1.32-1.574 2.775-1.997-.914c-.18.147-.386.29-.617.432-.232.14-.46.245-.686.313l-.338 2.132H5.943ZM7.5 9.7a2.12 2.12 0 0 0 1.557-.643A2.12 2.12 0 0 0 9.7 7.5a2.12 2.12 0 0 0-.643-1.557A2.12 2.12 0 0 0 7.5 5.3a2.12 2.12 0 0 0-1.557.643A2.12 2.12 0 0 0 5.3 7.5c0 .61.214 1.128.643 1.557A2.12 2.12 0 0 0 7.5 9.7Z",
    fill: "#697094",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.77966859.svg";
export { ForwardRef as ReactComponent };